<mat-selection-list>
    <div mat-subheader>Spalten anzeigen</div>
    <mat-list-option *ngFor="let columnConfig of columns; trackBy: identify" [value]="columnConfig.name" [selected]="selectedColumns.includes(columnConfig.name)">
        {{ columnConfig.header }}
    </mat-list-option>
</mat-selection-list>
